export default __webpack_public_path__ + "static/media/kanipakam-temple-preloader.b35dfe46.gif";